export const VideoControls = {
  PAUSE: 'pause',
  PLAY: 'play',
  SEEKING: 'seeking',
  SEEK: 'seek',
  TOGGLE_PAUSE: 'toggle_pause',
};
